//
//
//
//
//
//

import getphone from "../static/public.js";
export default {
  name: "App",
  data() {
    return {
      patientId: "",
      patientPwd: ""
    };
  },
  methods:{
    details(id,list){
      this.$doRequest('/api/Inquiry/orderDetails',{getPrescriptionOrder:'1',prescriptionOrderId:id.id},function(res){
        id.paystate = res.orderprescriptioninfos[0].paystate;
        list.ext.businessBody = JSON.stringify(id)
      })
    },
  },
  mounted() {
    var that = this;
    this.$imConn.listen({
      //im连接打开
      onOpened: function(message) {
        if (
          that.$store.state.websocketdosome["onOpened"] != null &&
          typeof that.$store.state.websocketdosome["onOpened"] == "function"
        ) {
          that.$store.state.websocketdosome["onOpened"](message);
        }
      },
      //接收普通文本信息
      onTextMessage: function(message) {
        message.isRead = false;
        if(message.ext.businessBody!=null &&typeof(message.ext.businessBody)=='string' &&message.ext.businessBody!=''){
          message.ext.businessBody=JSON.parse(message.ext.businessBody);
        }
        if(message.ext.businessType != null && message.ext.businessType != '' && message.ext.businessType == 'doctor_prescription'){
          message.ext.businessBody.paystate = '1';
        }
        if (
          that.$store.state.websocketdosome["onTextMessage"] != null &&
          typeof that.$store.state.websocketdosome["onTextMessage"] ==
            "function"
        ) {
          that.$msgDatas(
            that,
            "msgsuccess",
            message,
            message.from,
            "txt",
            that.$store.state.websocketdosome["onTextMessage"]
          );
        } else {
          that.$msgDatas(that, "msgsuccess", message, message.from, "txt");
        }
      },
      //im连接关闭
      onClosed: function(message) {
      },
      //im网络离线
      onOffline: function() {
        that.$imConn.close();
        if (that.$store.state.websocketdosome["onOffline"] != null && typeof that.$store.state.websocketdosome["onOffline"] == "function") {
          that.$store.state.websocketdosome["onOffline"]();
        }
      },
      onError: function(message) {
        if (message.data.data && typeof message.data.data == "string") {
          var data = JSON.parse(message.data.data);
          if (data.error_description == "user not found") {
            that.$register(that)
          }
        }
        if (that.$store.state.websocketdosome["onError"] != null && typeof that.$store.state.websocketdosome["onError"] == "function") {
          that.$store.state.websocketdosome["onError"](message)
        }
      },
      //接收表情信息
      onEmojiMessage: function(message) {
        message.isRead = false;
        if (
          that.$store.state.websocketdosome["onEmojiMessage"] != null &&
          typeof that.$store.state.websocketdosome["onEmojiMessage"] ==
            "function"
        ) {
          that.$msgDatas(
            that,
            "msgsuccess",
            message,
            message.from,
            "emoji",
            that.$store.state.websocketdosome["onEmojiMessage"]
          );
        } else {
          that.$msgDatas(that, "msgsuccess", message, message.from, "emoji");
        }
      },
      //接收图片消息
      onPictureMessage: function(message) {
        message.isRead = false;
        if (
          that.$store.state.websocketdosome["onPictureMessage"] != null &&
          typeof that.$store.state.websocketdosome["onPictureMessage"] ==
            "function"
        ) {
          that.$msgDatas(
            that,
            "msgsuccess",
            message,
            message.from,
            "img",
            that.$store.state.websocketdosome["onPictureMessage"]
          );
        } else {
          that.$msgDatas(that, "msgsuccess", message, message.from, "img");
        }
      },
      //接收音频消息
      onAudioMessage: function(message) {
        message.isRead = false;
        if (
          that.$store.state.websocketdosome["onAudioMessage"] != null &&
          typeof that.$store.state.websocketdosome["onAudioMessage"] ==
            "function"
        ) {
          that.$msgDatas(
            that,
            "msgsuccess",
            message,
            message.from,
            "voice",
            that.$store.state.websocketdosome["onAudioMessage"]
          );
        } else {
          that.$msgDatas(that, "msgsuccess", message, message.from, "voice");
        }
      },
      //收到消息已读回执
      onReadMessage: function(message) {

      },
      //收到消息送达服务器回执
      onReceivedMessage: function(message) {

      },
      //收到消息送达客户端回执
      onDeliveredMessage: function(message) {

      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/App.vue